import { AppMachineContext, usePopupItems, useRaundLifeCycleLoadingStatus } from '@/core/app/useRaundLifeCycle'
import { isMynaviMode } from '@/domain/campaign/campaignTypes'
import { HomePageInner, HomePageSkeleton } from '@/features/pages/home'
import { MyNaviHome } from '@/features/pages/mynavi/MyNaviHome'
import { useSelector } from '@xstate/react'
import type { NextPage } from 'next'

/** 通常キャンペーン用の内部コンポーネント（既存ロジックをそのまま移動） */
function RegularCampaignHome() {
  const { status } = useRaundLifeCycleLoadingStatus()
  const appActorRef = AppMachineContext.useActorRef()

  const isAuthenticated = useSelector(appActorRef, (s) => s.context.isAuthenticated)
  const campaignData = useSelector(appActorRef, (s) => s.context.campaignData)
  const isShowingConfirm = useSelector(appActorRef, (s) => s.matches({ phase3: { flow: 'showingConfirm' } }))
  const homePopupItems = usePopupItems('HOME')

  // ライフサイクル（認証チェック・キャンペーン取得・スタンプ状態の prefetch）が完了するまでスケルトンを表示する
  if (status === 'loading') return <HomePageSkeleton />

  return (
    <HomePageInner
      isAuthenticated={isAuthenticated}
      campaignData={campaignData}
      isShowingConfirm={isShowingConfirm}
      homePopupItems={homePopupItems}
      onConfirmClose={(skipNext) => appActorRef.send({ type: 'CONFIRM_CLOSED', skipNext })}
    />
  )
}

/** TOPページ。環境変数に応じてマイナビ or 通常ページを出し分ける */
const CampaignPage: NextPage = () => {
  if (isMynaviMode()) {
    return <MyNaviHome />
  }
  return <RegularCampaignHome />
}

export default CampaignPage

export { getStaticPaths, getStaticProps } from '@/core/app/getStaticFunctions'
